import {createModelSchemaWrapper, listOptional, rawCopy} from "framework/serializr-integration"
import {list, object, optional, primitive} from "serializr"
import {makeAutoObservable} from "mobx";

import {AgentState} from "framework/entities/agentState";
import {AssetTarget} from "framework/entities/asset";

import {AssetHealth} from "areas/assets/details/types/assetHealth";


export class AssetDetails {
	accountId: string
	accountName: string
	agentId: string
	agentName: string
	agentState?: AgentState
	agentStatus: string[]
	assetGroups: string[] = []
	assetMaintenance: boolean
	assetType: string
	calendar: any
	description: string
	externalId: string[]
	externalType: string[]
	geotag: any
	id: string
	imageId: string
	indicators: AssetHealth
	information: string
	maintenanceCalendars: any[]
	modified: number
	name: string
	shared: boolean
	systemType: string = 'GENERIC'
	tags: string[] = []
	targets: AssetTarget[] = []

	constructor(data?: Partial<AssetDetails>) {

		if (data) {
			Object.assign(this, data)
		}

		makeAutoObservable(this)
	}
}

createModelSchemaWrapper(AssetDetails, {
	accountId: primitive(),
	accountName: primitive(),
	agentId: primitive(),
	agentName: primitive(),
	agentStatus: listOptional(primitive()),
	agentState: primitive(),
	assetGroups: list(primitive()),
	assetMaintenance: primitive(),
	assetType: primitive(),
	calendar: rawCopy(),
	description: primitive(),
	externalId: list(primitive()),
	externalType: list(primitive()),
	geotag: rawCopy(),
	id: primitive(),
	imageId: primitive(),
	indicators: object(AssetHealth),
	information: primitive(),
	maintenanceCalendars: rawCopy(),
	modified: primitive(),
	name: primitive(),
	shared: primitive(),
	systemType: primitive(),
	tags: list(primitive()),
	targets: list(object(AssetTarget))
})

